export function initFaq() {
  const toggles = Array.from(document.querySelectorAll("[data-faq-toggle]"));
  if (!toggles.length) return;

  const setExpanded = (toggle, expanded) => {
    const panelId = toggle.getAttribute("aria-controls");
    const panel = panelId ? document.getElementById(panelId) : null;

    toggle.setAttribute("aria-expanded", String(expanded));
    if (panel) panel.hidden = !expanded;
  };

  toggles.forEach((toggle) => {
    setExpanded(toggle, toggle.getAttribute("aria-expanded") === "true");
    toggle.addEventListener("click", () => {
      const willExpand = toggle.getAttribute("aria-expanded") !== "true";
      toggles.forEach((item) => setExpanded(item, item === toggle && willExpand));
    });
  });
}
